import { render, staticRenderFns } from "./TournamentDashboardActionItem.vue?vue&type=template&id=5d5a6400&"
import script from "./TournamentDashboardActionItem.vue?vue&type=script&lang=js&"
export * from "./TournamentDashboardActionItem.vue?vue&type=script&lang=js&"
import style0 from "./TournamentDashboardActionItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports